import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';


// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchCurrentReadingSessionEvents,
  clearCurrentReadingSessionEvents
} from '../../modules/reader';

export class ReadingSessionEventsFeed extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    const { idToken, currentBook, session } = this.props;
    const { readerId } = this.props.match.params;
    this.props.fetchCurrentReadingSessionEvents(idToken, { bookId: currentBook._id, readerId: readerId, sessionId: session._id });
  }

  componentWillUnmount() {
    this.props.clearCurrentReadingSessionEvents();
  }

  getVerb = (logEvent) => {
    const {readingSessionEventData} = this.props;
    let verb = readingSessionEventData?.[logEvent.event]?.name || logEvent.event;
    if (logEvent.part) {
      verb += ' ' + logEvent.part.title;
    }
    return verb;
  }

  render() {
    const { session, readingSessionEvents } = this.props;
    const currentReadingSessionEvents = readingSessionEvents?.[session._id] || [];
    if (!currentReadingSessionEvents || !Array.isArray(currentReadingSessionEvents)) return null;
    return (
      <ul className="br-reading-session__event-list">
        {
          currentReadingSessionEvents.map(event => (
            <li key={event._id}>
              <span>{this.getVerb(event)}</span>
              <time dateTime={event.timestamp}>{new Date(event.timestamp).toLocaleString()}</time>
            </li>
          ))
        }
      </ul>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
  currentReader: state.reader.currentReader,
  readingSessionEventData: state.reader.readingSessionEventData,
  readingSessionEvents: state.reader.readingSessionEvents
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCurrentReadingSessionEvents,
  clearCurrentReadingSessionEvents,
  changePage: newPage => push(newPage)
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ReadingSessionEventsFeed));
